import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconSearch: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.7854 12.5947L10.6117 9.421C11.3758 8.4038 11.7883 7.16565 11.7869 5.89344C11.7869 2.64382 9.14306 0 5.89344 0C2.64382 0 0 2.64382 0 5.89344C0 9.14306 2.64382 11.7869 5.89344 11.7869C7.16566 11.7883 8.4038 11.3758 9.421 10.6117L12.5947 13.7854C12.942 14.0958 13.475 14.0659 13.7854 13.7187C14.0715 13.3987 14.0715 12.9148 13.7854 12.5947ZM1.68384 5.89344C1.68384 3.56854 3.56854 1.68384 5.89344 1.68384C8.21834 1.68384 10.103 3.56854 10.103 5.89344C10.103 8.21833 8.21834 10.103 5.89344 10.103C3.5697 10.1002 1.68664 8.21718 1.68384 5.89344Z" />
    </svg>
  </IconStyled>
);

IconSearch.defaultProps = iconDefaultProps;
IconSearch.displayName = 'IconSearch';

export default IconSearch;
